/**
 * The default fallback font list used for all text labels as an Array of Strings.
 * @defaultValue `["Inter", "Helvetica Neue", "HelveticaNeue", "Helvetica", "Arial", "sans-serif"]`
 */ export var fontFamily = [
    "Inter",
    "Helvetica Neue",
    "HelveticaNeue",
    "Helvetica",
    "Arial",
    "sans-serif"
];
/**
    Converts an Array of font-family names into a CSS font-family string.
    @param family A font family name or array of font family names.
*/ export function fontFamilyStringify(family) {
    return (typeof family === "string" ? [
        family
    ] : family).map(function(d) {
        return d.match(/^[a-z-_]{1,}$/) ? d : "'".concat(d, "'");
    }).join(", ");
}

//# sourceMappingURL=fontFamily.js.map